import { RemoteConstantsModel } from "../models/remoteConstants.model";
import {CommandBase} from "./commandBase";

export class AddBuildingLevelCommand extends CommandBase {
    id: string;

    constructor(id: string) {
        super();
        this.id = id;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.buildings.findIndex(b => b.id === this.id);
        if (index < 0) {
            return false;
        }

        // Ensure the dead Level 0 slot exists before adding new visible
        // levels. (See addBuilding.command.ts for why index 0 is reserved.)
        if (!Array.isArray(data.buildings[index].rewards) || data.buildings[index].rewards.length === 0) {
            data.buildings[index].rewards = [[]];
        }

        data.buildings[index].rewards.push([]);
        return true;
    }
}